<!-- Layout senza menu (accesso, uscita) -->
<empty-layout *ngIf="layout === 'empty'"></empty-layout>

<!-- Layout dell'area riservata: menu laterale e barra superiore -->
<classy-layout *ngIf="layout === 'classy'"></classy-layout>
